import { CaregiverAvailability } from "../../../messages/Caregiver";

export const initialCaregiverAvailability: CaregiverAvailability = {
  dayAvailabilities: [
    {
      day: 0,
      startHour: 0,
      endHour: 24,
      busyAllDay: false,
    },
    {
      day: 1,
      startHour: 0,
      endHour: 24,
      busyAllDay: false,
    },
    {
      day: 2,
      startHour: 0,
      endHour: 24,
      busyAllDay: false,
    },
    {
      day: 3,
      startHour: 0,
      endHour: 24,
      busyAllDay: false,
    },
    {
      day: 4,
      startHour: 0,
      endHour: 24,
      busyAllDay: false,
    },
    {
      day: 5,
      startHour: 0,
      endHour: 24,
      busyAllDay: false,
    },
    {
      day: 6,
      startHour: 0,
      endHour: 24,
      busyAllDay: false,
    },
  ],
  minDuration: 1,
  maxDuration: 24,
  maxDistance: 30,
};
